var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.664,
    height: 39.653,
    viewBox: "0 0 39.664 39.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 39.664,
    height: 39.653,
    fill: "#8e48cc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_385",
    "data-name": "Groupe 385",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_344",
    "data-name": "Groupe 344",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2831",
    "data-name": "Trac\\xE9 2831",
    d: "M0,28.379a1.68,1.68,0,0,1,1.131-1.068q5.893-2.34,11.775-4.709a1.816,1.816,0,0,1,1.453,0c2.34.953,4.688,1.882,7.032,2.824a1.246,1.246,0,1,1-.908,2.3c-1.737-.689-3.47-1.387-5.206-2.081-.117-.047-.236-.088-.4-.15v.448q0,9.374-.009,18.747a.545.545,0,0,0,.424.6c3.033,1.2,6.059,2.414,9.086,3.625.118.047.237.092.415.16V48.6q0-6.139,0-12.278a2.825,2.825,0,0,1,.023-.5,1.235,1.235,0,0,1,2.443.092,4.049,4.049,0,0,1,.012.464q0,6.12,0,12.24v.466c.579-.229,1.116-.438,1.651-.652,2.633-1.053,5.262-2.113,7.9-3.153a.5.5,0,0,0,.372-.561c-.01-4.48,0-8.96-.011-13.44a1.3,1.3,0,0,1,.719-1.3,1.23,1.23,0,0,1,1.752.994,3.889,3.889,0,0,1,.01.426q0,7.108,0,14.215a1.4,1.4,0,0,1-1.1,1.636q-5.922,2.371-11.844,4.746a1.738,1.738,0,0,1-1.381,0c-3.765-1.518-7.536-3.02-11.3-4.538a.989.989,0,0,0-.806,0Q7.653,49.7,2.068,51.926c-1.062.425-1.488.281-2.068-.692ZM2.479,49.074c.154-.057.273-.1.389-.144,3.051-1.219,6.1-2.444,9.157-3.651a.5.5,0,0,0,.378-.557q-.016-9.411-.009-18.821c0-.122-.011-.245-.019-.4-.154.058-.272.1-.389.148-3.039,1.215-6.076,2.437-9.12,3.639a.524.524,0,0,0-.4.583q.015,9.392.008,18.783Z",
    transform: "translate(0 -12.498)",
    fill: "#8e48cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2832",
    "data-name": "Trac\\xE9 2832",
    d: "M59.81,0c.8.2,1.615.34,2.383.62A8.634,8.634,0,0,1,67.7,8.666a9.286,9.286,0,0,1-1.189,4.008,42.679,42.679,0,0,1-5.6,8.1c-.307.366-.609.736-.932,1.088a1.211,1.211,0,0,1-1.9,0,45.664,45.664,0,0,1-6.515-9.152,9.824,9.824,0,0,1-1.15-3.425A8,8,0,0,1,51.927,3.73,8.48,8.48,0,0,1,58,.07,1.911,1.911,0,0,0,58.26,0Zm-.781,19.194a41,41,0,0,0,5.556-8.22,5.283,5.283,0,0,0,.639-2.524,6.2,6.2,0,0,0-9.664-4.9,5.864,5.864,0,0,0-2,7.633,42.24,42.24,0,0,0,3.618,5.663c.588.78,1.207,1.536,1.848,2.348",
    transform: "translate(-28.047 0)",
    fill: "#8e48cc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2833",
    "data-name": "Trac\\xE9 2833",
    d: "M65.228,18.623a3.716,3.716,0,1,1,3.73-3.712,3.753,3.753,0,0,1-3.73,3.712m1.25-3.733a1.237,1.237,0,1,0-1.211,1.254,1.245,1.245,0,0,0,1.211-1.254",
    transform: "translate(-34.254 -6.231)",
    fill: "#8e48cc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon2);
export default __webpack_public_path__ + "static/media/map-icon-2.7563d7b52dca4329e0b37ba5dca7cd12.svg";
export { ForwardRef as ReactComponent };